import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import {
  Badge,
  Button,
  Menu,
  TextInput,
  MultiSelect,
  ActionIcon,
  Group,
  Card,
  Collapse,
  Tooltip,
  Flex,
  Modal,
} from "@mantine/core";
import { MantineReactTable } from "mantine-react-table";
import {
  IconX,
  IconCheck,
  IconTrash,
  IconFilter,
  IconMoodEmptyFilled,
  IconHourglassEmpty,
  IconTrashX,
  IconArrowNarrowLeft,
  IconFilterPlus,
  IconFilterCancel,
  IconShoppingCartPlus,
} from "@tabler/icons-react";
import { DatePicker } from "@mantine/dates";
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import config from "config";
import { toast } from "react-toastify";

const FiltreMantineTable = forwardRef((props, ref) => {
  const {
    columns,
    data,
    table,
    api,
    setData,
    pagination,
    setQuery,
    setActif,
    actif,
    nomControlleur,
    getFilters,
    isModalOpen,
    setModalOpen,
    openModal,
    closeModal,
    load_filters,
    setSelectedOptionFilters,
    setSelectedOptionId,
  } = props;
  const [menuOpen, setMenuOpen] = useState(false);
  const api_2 = config.backOffice.apiName;

  const [filterName, setFilterName] = useState("");
  const [filters, setFilters] = useState(actif);
  const [pendingFilters, setPendingFilters] = useState([]);
  const [menuState, setMenuState] = useState({
    selectedColumn: "",
    selectedCondition: "",
    value: "",
  });
  const [clickOutside, setClickOutside] = useState(true);
  const token = localStorage.getItem("auth_token_" + api_2);
  const dispatch = useDispatch();
  // Appliquer les filtres sur les données chaque fois que les filtres changent
  useEffect(() => {
    applyFilters();
  }, [filters]);
  console.log("filters", filters);
  // Exposer des méthodes via la ref
  useImperativeHandle(ref, () => ({
    createFilter: handleCreateFilter,
    filters: filters,
  }));
  // Creation du filtre
  const handleCreateFilter = async () => {
    if (!filters || Object.keys(filters).length === 0) {
      toast.error("Aucun filtre à enregistrer");
      return;
    }
    if (!filterName) {
      toast.error("Veuillez entrer un nom pour le filtre !");
      return;
    }

    // Fonction pour traiter un filtre individuel
    const processFilter = (key, filterObj, acc) => {
      const { value, operator, type } = filterObj;

      if (type === "text") {
        if (operator === "commence par") acc[key + "_like"] = `^${value}`;
        if (operator === "contient") acc[key + "_like"] = `${value}`;
        if (operator === "fini par") acc[key + "_like"] = `${value}$`;
        if (operator === "égale à") acc[key + "_equals"] = `${value}`;
        if (operator === "est vide") acc[key + "_is_null"] = true;
      }

      if (type === "number") {
        if (operator === "supérieur à") acc[key + "_gt"] = `${value}`;
        if (operator === "supérieur ou égal à") acc[key + "_gte"] = `${value}`;
        if (operator === "inférieur à") acc[key + "_lt"] = `${value}`;
        if (operator === "inférieur ou égal à") acc[key + "_lte"] = `${value}`;
        if (operator === "égale à") acc[key + "_equals"] = `${value}`;
        if (operator === "est vide") acc[key + "_is_null"] = true;
      }

      if (type === "select") {
        const selectedValues = Array.isArray(value) ? value : [value];
        acc[key] = selectedValues.join(",");
      }

      if (type === "date") {
        let formattedValue;

        try {
          const dateObj = new Date(value);

          // Vérifier si la date est valide
          if (isNaN(dateObj.getTime())) {
            // Date invalide : utiliser la date actuelle comme fallback
            const today = new Date();
            formattedValue = `${today.getDate().toString().padStart(2, "0")}/${(
              today.getMonth() + 1
            )
              .toString()
              .padStart(2, "0")}/${today.getFullYear()}`;
            console.warn(
              `Date invalide "${value}" remplacée par la date actuelle`
            );
          } else {
            // Date valide : formater en DD/MM/YYYY
            formattedValue = `${dateObj
              .getDate()
              .toString()
              .padStart(2, "0")}/${(dateObj.getMonth() + 1)
              .toString()
              .padStart(2, "0")}/${dateObj.getFullYear()}`;
          }
        } catch (error) {
          // En cas d'erreur, utiliser la date actuelle
          const today = new Date();
          formattedValue = `${today.getDate().toString().padStart(2, "0")}/${(
            today.getMonth() + 1
          )
            .toString()
            .padStart(2, "0")}/${today.getFullYear()}`;
          console.error("Erreur de formatage de date:", error);
        }
        if (operator === "après ou égal à") acc[key + "_gte"] = `${value}`;
        if (operator === "avant ou égal à") acc[key + "_lte"] = `${value}`;
        if (operator === "égale à") acc[key + "_equals"] = formattedValue;
        if (operator === "avant") acc[key + "_lt"] = formattedValue;
        if (operator === "après") acc[key + "_gt"] = formattedValue;
        if (operator === "est vide") acc[key + "_is_null"] = true;
      }

      return acc;
    };

    // Le reste du code reste identique...
    const filterParams = Object.keys(filters).reduce((acc, key) => {
      const filterValue = filters[key];

      if (Array.isArray(filterValue)) {
        const conditionMap = new Map();

        filterValue.forEach((filter) => {
          const { operator, type } = filter;
          let conditionKey;

          if (type === "text") {
            if (operator === "commence par") conditionKey = `${key}_like_start`;
            if (operator === "contient") conditionKey = `${key}_like`;
            if (operator === "fini par") conditionKey = `${key}_like_end`;
            if (operator === "égale à") conditionKey = `${key}_equals`;
            if (operator === "est vide") conditionKey = `${key}_is_null`;
          }

          if (type === "number") {
            if (operator === "supérieur à") conditionKey = `${key}_gt`;
            if (operator === "supérieur ou égal à") conditionKey = `${key}_gte`;
            if (operator === "inférieur à") conditionKey = `${key}_lt`;
            if (operator === "inférieur ou égal à") conditionKey = `${key}_lte`;
            if (operator === "égale à") conditionKey = `${key}_equals`;
            if (operator === "est vide") conditionKey = `${key}_is_null`;
          }

          if (type === "select") {
            conditionKey = `${key}`;
          }

          if (type === "date") {
            if (operator === "égale à") conditionKey = `${key}_equals`;
            if (operator === "avant") conditionKey = `${key}_lt`;
            if (operator === "après") conditionKey = `${key}_gt`;
            if (operator === "est vide") conditionKey = `${key}_is_null`;
            if (operator === "avant ou égal à") conditionKey = `${key}_lte`;
            if (operator === "après ou égal à") conditionKey = `${key}_gte`;
          }

          if (conditionKey) {
            conditionMap.set(conditionKey, filter);
          }
        });

        conditionMap.forEach((filter) => {
          processFilter(key, filter, acc);
        });
      } else {
        processFilter(key, filterValue, acc);
      }

      return acc;
    }, {});

    const filterPayload = {
      name: filterName,
      controlleur: nomControlleur,
      filter_params: filterParams,
    };

    try {
      const response = await fetch(
        `https://www.fluxod.com/${api_2}/preferences_filters/create_filter`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(filterPayload),
        }
      );

      if (response.ok) {
        const result = await response.json();
        console.log("Filtre créé avec succès:", result);
        dispatch(setSelectedOptionId(result.id));
        toast.success("Filtre enregistré avec succès !");
        setFilterName("");
        getFilters();
        closeModal();
      } else {
        console.error(
          "Erreur lors de la création du filtre:",
          response.statusText
        );
        toast.error("Échec de l'enregistrement du filtre.");
      }
    } catch (error) {
      console.error("Erreur réseau lors de la création du filtre:", error);
      toast.error("Erreur réseau. Veuillez réessayer.");
    }
  };

  // Load the filters
  // const transformFilterParams = () => {
  //   const result = {};

  //   Object.keys(load_filters)?.forEach((key) => {
  //     const value = load_filters[key];
  //     let baseKey = key;
  //     let operator = null;
  //     let type = "text";

  //     if (key.endsWith("_like")) {
  //       baseKey = key.replace("_like", "");
  //       type = "text";
  //       if (value.startsWith("^")) {
  //         operator = "commence par";
  //       } else if (value.endsWith("$")) {
  //         operator = "fini par";
  //       } else {
  //         operator = "contient";
  //       }
  //     } else if (key.endsWith("_gt")) {
  //       baseKey = key.replace("_gt", "");
  //       type = key.includes("date") ? "date" : "number";
  //       operator = type === "date" ? "après" : "supérieur à";
  //     } else if (key.endsWith("_lt")) {
  //       baseKey = key.replace("_lt", "");
  //       type = key.includes("date") ? "date" : "number";
  //       operator = type === "date" ? "avant" : "inférieur à";
  //     } else if (key.endsWith("_equals")) {
  //       baseKey = key.replace("_equals", "");
  //       type = key.includes("date")
  //         ? "date"
  //         : key.includes("number")
  //         ? "number"
  //         : "text";
  //       operator = "égale à";
  //     } else if (key.endsWith("_is_null")) {
  //       baseKey = key.replace("_is_null", "");
  //       type = key.includes("date")
  //         ? "date"
  //         : key.includes("number")
  //         ? "number"
  //         : "text";
  //       operator = "est vide";
  //     } else {
  //       type = "select";
  //       operator = "select";
  //     }

  //     const parsedValue = type === "select" ? value.split(",") : value;

  //     result[baseKey] = {
  //       type,
  //       operator,
  //       value:
  //         typeof value === "boolean"
  //           ? ""
  //           : type === "text"
  //           ? value?.replace(/[\^\$]/g, "")
  //           : parsedValue,
  //     };
  //   });

  //   return result;
  // };
  const transformFilterParams = () => {
    const tempResult = {}; // Stockage temporaire avec clés composites
    const result = {}; // Résultat final groupé par baseKey

    Object.keys(load_filters)?.forEach((key) => {
      const value = load_filters[key];
      let baseKey = key;
      let operator = null;
      let type = "text";

      if (key.endsWith("_like")) {
        baseKey = key.replace("_like", "");
        type = "text";
        if (value.startsWith("^")) {
          operator = "commence par";
        } else if (value.endsWith("$")) {
          operator = "fini par";
        } else {
          operator = "contient";
        }
      } else if (key.endsWith("_gt")) {
        baseKey = key.replace("_gt", "");
        type = key.includes("date") ? "date" : "number";
        operator = type === "date" ? "après" : "supérieur à";
      } else if (key.endsWith("_gte")) {
        baseKey = key.replace("_gte", "");
        type = key.includes("date") ? "date" : "number";
        operator = type === "date" ? "après ou égal à" : "supérieur ou égal à";
      } else if (key.endsWith("_lt")) {
        baseKey = key.replace("_lt", "");
        type = key.includes("date") ? "date" : "number";
        operator = type === "date" ? "avant" : "inférieur à";
      } else if (key.endsWith("_lte")) {
        baseKey = key.replace("_lte", "");
        type = key.includes("date") ? "date" : "number";
        operator = type === "date" ? "avant ou égal à" : "inférieur ou égal à";
      } else if (key.endsWith("_equals")) {
        baseKey = key.replace("_equals", "");
        type = key.includes("date")
          ? "date"
          : key.includes("number")
          ? "number"
          : "text";
        operator = "égale à";
      } else if (key.endsWith("_is_null")) {
        baseKey = key.replace("_is_null", "");
        type = key.includes("date")
          ? "date"
          : key.includes("number")
          ? "number"
          : "text";
        operator = "est vide";
      } else {
        type = "select";
        operator = "select";
      }

      const parsedValue = type === "select" ? value.split(",") : value;

      // Clé composite pour éviter doublons de conditions
      const conditionKey = `${baseKey}_${operator}`;

      // Stocker avec remplacement automatique si même condition
      tempResult[conditionKey] = {
        baseKey,
        type,
        operator,
        value:
          typeof value === "boolean"
            ? ""
            : type === "text"
            ? value?.replace(/[\^\$]/g, "")
            : parsedValue,
      };
    });

    // Regrouper par baseKey
    Object.values(tempResult).forEach(({ baseKey, type, operator, value }) => {
      const filterObj = { type, operator, value };

      if (result[baseKey]) {
        // Si la baseKey existe déjà
        if (Array.isArray(result[baseKey])) {
          // Si c'est déjà un tableau, vérifier si l'opérateur existe
          const existingIndex = result[baseKey].findIndex(
            (filter) => filter.operator === operator
          );

          if (existingIndex !== -1) {
            // Remplacer l'ancien filtre
            result[baseKey][existingIndex] = filterObj;
          } else {
            // Ajouter le nouveau filtre
            result[baseKey].push(filterObj);
          }
        } else {
          // Si c'est un objet simple, vérifier l'opérateur
          if (result[baseKey].operator === operator) {
            // Remplacer directement
            result[baseKey] = filterObj;
          } else {
            // Convertir en tableau avec l'ancien et le nouveau
            result[baseKey] = [result[baseKey], filterObj];
          }
        }
      } else {
        // Nouvelle baseKey
        result[baseKey] = filterObj;
      }
    });

    return result;
  };

  const [isFirstRender, setIsFirstRender] = useState(true);

  useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false); // Marque le premier rendu comme terminé
      return; // Sortie anticipée pour éviter l'exécution
    }

    setFilters(transformFilterParams());
  }, [load_filters]);

  // Appliquer les filtres
  const applyFilters = async () => {
    const buildQueryPart = (key, filterObj) => {
      const { value, type, operator } = filterObj;

      if (!value && operator !== "est vide") return null;

      if (type === "text") {
        if (operator === "commence par")
          return { query: `${key}_like=^${value}`, operator: "like" };
        if (operator === "contient")
          return { query: `${key}_like=${value}`, operator: "like" };
        if (operator === "fini par")
          return { query: `${key}_like=${value}$`, operator: "like" };
        if (operator === "égale à")
          return { query: `${key}_equals=${value}`, operator: "equals" };
        if (operator === "est vide")
          return { query: `${key}_is_null=true`, operator: "is_null" };
      }

      if (type === "number") {
        if (operator === "supérieur à")
          return { query: `${key}_gt=${value}`, operator: "gt" };
        if (operator === "supérieur ou égal à")
          return { query: `${key}_gte=${value}`, operator: "gte" };
        if (operator === "inférieur à")
          return { query: `${key}_lt=${value}`, operator: "lt" };
        if (operator === "inférieur ou égal à")
          return { query: `${key}_lte=${value}`, operator: "lte" };
        if (operator === "égale à")
          return { query: `${key}_equals=${value}`, operator: "equals" };
        if (operator === "est vide")
          return { query: `${key}_is_null=true`, operator: "is_null" };
      }

      if (type === "select") {
        const selectedValues = Array.isArray(value) ? value : [value];
        return { query: `${key}=${selectedValues.join(",")}`, operator: "in" };
      }

      if (type === "date") {
        if (operator === "égale à")
          return { query: `${key}_equals=${value}`, operator: "equals" };
        if (operator === "avant")
          return { query: `${key}_lt=${value}`, operator: "lt" };
        if (operator === "après")
          return { query: `${key}_gt=${value}`, operator: "gt" };
        if (operator === "est vide")
          return { query: `${key}_is_null=true`, operator: "is_null" };
        if (operator === "avant ou égal à")
          return { query: `${key}_lte=${value}`, operator: "lte" };
        if (operator === "après ou égal à")
          return { query: `${key}_gte=${value}`, operator: "gte" };
      }

      return null;
    };

    const conditionMap = new Map(); // Clé: "column_operator", Valeur: query string

    Object.keys(filters).forEach((key) => {
      const filterValue = filters[key];

      if (Array.isArray(filterValue)) {
        filterValue.forEach((filter) => {
          const result = buildQueryPart(key, filter);
          if (result) {
            const conditionKey = `${key}_${result.operator}`;
            // Si la condition existe déjà, elle sera remplacée (dernier filtre gagne)
            conditionMap.set(conditionKey, result.query);
          }
        });
      } else {
        const result = buildQueryPart(key, filterValue);
        if (result) {
          const conditionKey = `${key}_${result.operator}`;
          conditionMap.set(conditionKey, result.query);
        }
      }
    });

    // Convertir la Map en array de queries
    const query = Array.from(conditionMap.values()).join("&");

    dispatch(setActif(filters));
    dispatch(setQuery(query));
  };

  const handleAddPendingFilter = () => {
    const { selectedColumn, selectedCondition, value } = menuState;

    const newFilter = {
      column: selectedColumn,
      condition: selectedCondition,
      value,
    };

    setPendingFilters((prev) => {
      // Chercher l'index du filtre existant avec la même colonne/condition
      const existingIndex = prev.findIndex(
        (filter) =>
          filter.column === newFilter.column &&
          filter.condition === newFilter.condition
      );

      if (existingIndex !== -1) {
        // Remplacer le filtre existant
        const newArray = [...prev];
        newArray[existingIndex] = newFilter;
        return newArray;
      } else {
        // Ajouter le nouveau filtre
        return [...prev, newFilter];
      }
    });

    setMenuState({ selectedColumn: "", selectedCondition: "", value: "" });
    setClickOutside(true);
    setMenuOpen(false);
  };

  const handleApplyPendingFilters = () => {
    const newFilters = { ...filters };
    const operatorMap = {
      "Commence par": "commence par",
      Contient: "contient",
      "Fini par": "fini par",
      Égale: "égale à",
      Avant: "avant",
      Après: "après",
      "Supérieur à": "supérieur à",
      "Inférieur à": "inférieur à",
      select: "select",
      "Est vide": "est vide",
      "Supérieur ou égal à": "supérieur ou égal à",
      "Inférieur ou égal à": "inférieur ou égal à",
      "Avant ou égal à": "avant ou égal à",
      "Après ou égal à": "après ou égal à",
    };

    pendingFilters.forEach(({ column, condition, value }) => {
      const newFilter = {
        type: columns.find((col) => col.accessorKey === column).type,
        operator: operatorMap[condition],
        value,
      };

      if (newFilters[column]) {
        if (Array.isArray(newFilters[column])) {
          // Chercher si une condition identique existe déjà
          const existingIndex = newFilters[column].findIndex(
            (filter) => filter.operator === newFilter.operator
          );

          if (existingIndex !== -1) {
            // Remplacer l'ancien filtre par le nouveau
            newFilters[column][existingIndex] = newFilter;
          } else {
            // Ajouter le nouveau filtre (condition différente)
            newFilters[column].push(newFilter);
          }
        } else {
          // Si c'est un objet simple, vérifier la condition
          if (newFilters[column].operator === newFilter.operator) {
            // Remplacer directement (même condition)
            newFilters[column] = newFilter;
          } else {
            // Transformer en tableau avec l'ancien et le nouveau filtre
            newFilters[column] = [newFilters[column], newFilter];
          }
        }
      } else {
        // Nouvelle colonne, créer un nouveau filtre
        newFilters[column] = newFilter;
      }
    });

    setFilters(newFilters);
    setPendingFilters([]);
  };

  const handleRemoveFilter = (column, index = null) => {
    setFilters((prev) => {
      const newFilters = { ...prev };

      if (index !== null && Array.isArray(newFilters[column])) {
        // Supprimer un filtre spécifique dans un tableau
        const updatedArray = newFilters[column].filter((_, i) => i !== index);

        if (updatedArray.length === 0) {
          // Si plus de filtres pour cette colonne, supprimer la clé
          delete newFilters[column];
        } else if (updatedArray.length === 1) {
          // Si un seul filtre reste, le convertir en objet simple
          newFilters[column] = updatedArray[0];
        } else {
          // Sinon, garder le tableau
          newFilters[column] = updatedArray;
        }
      } else {
        // Supprimer toute la colonne (comportement original)
        delete newFilters[column];
      }

      return newFilters;
    });
  };
  const handleRemovePendingFilter = (index) => {
    setPendingFilters((prev) => prev.filter((_, i) => i !== index));
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleAddPendingFilter();
    }
  };
  return (
    <>
      <div>
        {/* /* Modal pour le nom du filtre à enregistrer */}
        <Modal
          opened={isModalOpen}
          onClose={closeModal}
          title="Enregistrer un nouveau filtre"
          centered
        >
          {pendingFilters.length > 0 && (
            <Badge color="orange" variant="filled" mb="md">
              Les filtres en attente ne seront pas sauvegardés
            </Badge>
          )}
          <TextInput
            label="Nom du filtre"
            placeholder="Entrez un nom pour le filtre"
            value={filterName}
            onChange={(event) => setFilterName(event.target.value)}
          />
          <Group position="right" mt="md">
            <Button variant="default" onClick={closeModal}>
              Annuler
            </Button>
            <Button onClick={handleCreateFilter}>Enregistrer</Button>
          </Group>
        </Modal>
        <Flex direction="row" gap="7">
          {/* Filtre actif  */}
          <div
            style={{ display: "flex", flexWrap: "wrap", gap: "2px" }}
            className={
              Object.keys(filters).length > 0 ? "input-group-text p-1" : "p-1"
            }
          >
            {Object.keys(columns).length > 0 &&
              (() => {
                const uniqueConditions = new Map(); // Clé: "column_operator", Valeur: filtre

                // Collecter tous les filtres et garder seulement les uniques par condition
                Object.keys(filters).forEach((column) => {
                  const filterValue = filters[column];
                  const columnHeader = columns.find(
                    (header) => header.accessorKey === column
                  );

                  if (Array.isArray(filterValue)) {
                    filterValue.forEach((filter, index) => {
                      const conditionKey = `${column}_${filter.operator}`;
                      // Garde le dernier filtre pour cette condition (remplace si existe)
                      uniqueConditions.set(conditionKey, {
                        column,
                        filter,
                        index,
                        columnHeader,
                        isArray: true,
                      });
                    });
                  } else {
                    const conditionKey = `${column}_${filterValue.operator}`;
                    uniqueConditions.set(conditionKey, {
                      column,
                      filter: filterValue,
                      index: null,
                      columnHeader,
                      isArray: false,
                    });
                  }
                });

                // Convertir la Map en array de badges
                return Array.from(uniqueConditions.values()).map(
                  ({ column, filter, index, columnHeader, isArray }) => (
                    <Badge
                      key={`${column}-${filter.operator}`}
                      color="blue"
                      rightSection={
                        <ActionIcon
                          size="xs"
                          color="blue"
                          onClick={() =>
                            handleRemoveFilter(
                              column,
                              isArray ? index : undefined
                            )
                          }
                        >
                          <IconX size={10} />
                        </ActionIcon>
                      }
                    >
                      <span
                        style={{ fontWeight: "normal", textTransform: "none" }}
                      >
                        {`${columnHeader.header} ${filter.operator}${
                          filter.operator === "est vide" ? "" : ":"
                        } ${
                          filter.type === "select"
                            ? (() => {
                                const statut = String(filter.value);
                                const statutOptions =
                                  columnHeader?.options || [];
                                const statutLabels = statut
                                  .split(",")
                                  .map((val) => {
                                    const match = statutOptions.find(
                                      (option) => option.value === parseInt(val)
                                    );
                                    return match ? match.label : null;
                                  })
                                  .filter((label) => label !== null);
                                return statutLabels.join(", ");
                              })()
                            : filter.value
                        }`}
                      </span>
                    </Badge>
                  )
                );
              })()}
          </div>

          <Menu
            shadow="md"
            width={400}
            closeOnItemClick={false}
            closeOnClickOutside={clickOutside}
            opened={menuOpen}
            onClose={() => setMenuOpen(false)}
          >
            <Menu.Target
              style={{
                width: "auto",
                display: "block",
                marginLeft: "auto",
              }}
            >
              <Tooltip
                label="Ajouter un filtre"
                withArrow
                position="top"
                withinPortal
              >
                <IconFilter
                  size={24}
                  className="m-1"
                  onClick={() => setMenuOpen((prev) => !prev)}
                  color="blue"
                  style={{ cursor: "pointer" }}
                />
              </Tooltip>
            </Menu.Target>{" "}
            {Object.entries(filters).length > 0 ? (
              <Tooltip
                label="Vider le filtre"
                withArrow
                position="top"
                withinPortal
              >
                <IconFilterCancel
                  className="m-1"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setFilters({});
                    dispatch(setSelectedOptionFilters(null));
                  }}
                  color="red"
                />
              </Tooltip>
            ) : null}
            <Menu.Dropdown>
              {!menuState.selectedColumn &&
                columns.map((header) => (
                  <Menu.Item
                    key={header.accessorKey}
                    onClick={() => {
                      setMenuState((prev) => ({
                        ...prev,
                        selectedColumn: header.accessorKey,
                      }));
                    }}
                  >
                    {header.header}
                  </Menu.Item>
                ))}

              {menuState.selectedColumn &&
                (!menuState.selectedCondition ||
                  menuState.selectedCondition == "select") && (
                  <>
                    <Menu.Item>
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          onClick={() => {
                            setMenuState((prev) => ({
                              ...prev,
                              selectedColumn: "",
                              selectedCondition: "",
                              value: "",
                            })),
                              setClickOutside(true);
                          }}
                        >
                          <IconArrowNarrowLeft /> Retour
                        </Button>
                        {columns.find(
                          (header) =>
                            header.accessorKey === menuState.selectedColumn
                        )?.type === "select" ? (
                          <Button
                            onClick={handleAddPendingFilter}
                            color="green"
                          >
                            Ajouter aux filtres en attentes
                          </Button>
                        ) : null}
                      </div>
                    </Menu.Item>
                    {columns.find(
                      (header) =>
                        header.accessorKey === menuState.selectedColumn
                    ).type === "text" &&
                      [
                        "Commence par",
                        "Contient",
                        "Fini par",
                        "Égale",
                        "Est vide",
                      ].map((condition) => (
                        <Menu.Item
                          key={condition}
                          onClick={() =>
                            setMenuState((prev) => ({
                              ...prev,
                              selectedCondition: condition,
                            }))
                          }
                          style={{
                            backgroundColor:
                              condition == "Est vide" ? "#FFDD57" : "",
                          }}
                        >
                          {condition}
                        </Menu.Item>
                      ))}
                    {columns.find(
                      (header) =>
                        header.accessorKey === menuState.selectedColumn
                    ).type === "number" &&
                      [
                        "Supérieur à",
                        "Supérieur ou égal à",
                        "Inférieur à",
                        "Inférieur ou égal à",
                        "Égale",
                        "Est vide",
                      ].map((condition) => (
                        <Menu.Item
                          key={condition}
                          onClick={() =>
                            setMenuState((prev) => ({
                              ...prev,
                              selectedCondition: condition,
                            }))
                          }
                          style={{
                            backgroundColor:
                              condition == "Est vide" ? "#FFDD57" : "",
                          }}
                        >
                          {condition}
                        </Menu.Item>
                      ))}
                    {columns.find(
                      (header) =>
                        header.accessorKey === menuState.selectedColumn
                    ).type === "date" &&
                      [
                        "Avant",
                        "Avant ou égal à",
                        "Après",
                        "Après ou égal à",
                        "Égale",
                        "Est vide",
                      ].map((condition) => (
                        <Menu.Item
                          key={condition}
                          onClick={() =>
                            setMenuState((prev) => ({
                              ...prev,
                              selectedCondition: condition,
                            }))
                          }
                          style={{
                            backgroundColor:
                              condition == "Est vide" ? "#FFDD57" : "",
                          }}
                        >
                          {condition}
                        </Menu.Item>
                      ))}
                  </>
                )}
              {columns.find(
                (header) => header.accessorKey === menuState.selectedColumn
              )?.type === "select" && (
                <>
                  <Menu.Item closeOnClick={false}>
                    <MultiSelect
                      onKeyDown={handleKeyDown}
                      withinPortal
                      data={
                        columns
                          .find(
                            (header) =>
                              header.accessorKey === menuState.selectedColumn
                          )
                          ?.options.map((option) => ({
                            value: String(option.value),
                            label: String(option.label),
                          })) || []
                      }
                      value={menuState.value || []}
                      onChange={(value) =>
                        setMenuState((prev) => ({
                          ...prev,
                          selectedCondition: "select",
                          value,
                        }))
                      }
                      placeholder={`Sélectionnez pour ${
                        columns.find(
                          (header) =>
                            header.accessorKey === menuState.selectedColumn
                        )?.header || ""
                      }`}
                      onClick={() => setClickOutside(!clickOutside)}
                      renderOption={(option) => (
                        <div
                          style={{
                            backgroundColor:
                              option.option.label == "[ est vide ]"
                                ? "#FFDD57"
                                : "transparent",
                            color:
                              option.option.label == "[ est vide ]"
                                ? "black"
                                : "inherit",

                            padding: "8px 12px",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                        >
                          {option.option.label}
                        </div>
                      )}
                    />
                  </Menu.Item>
                  {/* <Menu.Item>
                    <Menu.Item
                      key="Est vide"
                      onClick={() =>
                        setMenuState((prev) => ({
                          ...prev,
                          selectedCondition: "Est vide",
                          value: "",
                        }))
                      }
                    >
                      Est vide
                    </Menu.Item>
                  </Menu.Item> */}
                  {/* <Menu.Item onClick={handleAddPendingFilter}>
                    <Button color="green">
                      Ajouter aux filtres en attente
                    </Button>
                  </Menu.Item> */}
                </>
              )}
              {menuState.selectedColumn &&
                menuState.selectedCondition &&
                menuState.selectedCondition !== "select" && (
                  <>
                    <Menu.Item
                    // onClick={() =>
                    //   setMenuState((prev) => ({
                    //     ...prev,
                    //     selectedCondition: "",
                    //     value: "",
                    //   }))
                    // }
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          onClick={() => {
                            setMenuState((prev) => ({
                              ...prev,
                              selectedColumn: "",
                              selectedCondition: "",
                              // value: "",
                            })),
                              setClickOutside(true);
                          }}
                        >
                          <IconArrowNarrowLeft /> Retour
                        </Button>
                        {columns.find(
                          (header) =>
                            header.accessorKey === menuState.selectedColumn
                        )?.type != "select" ? (
                          <Button
                            onClick={handleAddPendingFilter}
                            color="green"
                          >
                            Ajouter aux filtres en attentes
                          </Button>
                        ) : null}
                      </div>
                    </Menu.Item>
                    {menuState.selectedCondition !== "Est vide" && (
                      <Menu.Item>
                        {columns.find(
                          (header) =>
                            header.accessorKey === menuState.selectedColumn
                        ).type === "date" ? (
                          <DatePicker
                            // format="dd/MM/yyyy"
                            placeholder="Sélectionnez une date"
                            value={
                              menuState.value
                                ? new Date(
                                    menuState.value
                                      .split("/")
                                      .reverse()
                                      .join("-")
                                  )
                                : null
                            }
                            onChange={(date) =>
                              setMenuState((prev) => ({
                                ...prev,
                                value: date
                                  ? `${date
                                      .getDate()
                                      .toString()
                                      .padStart(2, "0")}/${(date.getMonth() + 1)
                                      .toString()
                                      .padStart(2, "0")}/${date.getFullYear()}`
                                  : "",
                              }))
                            }
                          />
                        ) : (
                          <TextInput
                            placeholder={`${
                              columns.find(
                                (header) =>
                                  header.accessorKey ===
                                  menuState.selectedColumn
                              ).header
                            } ${menuState.selectedCondition.toLowerCase()}`}
                            value={menuState.value}
                            onChange={(e) =>
                              setMenuState((prev) => ({
                                ...prev,
                                value: e.target.value,
                              }))
                            }
                            onKeyDown={handleKeyDown}
                          />
                        )}
                      </Menu.Item>
                    )}
                    {/* <Menu.Item onClick={handleAddPendingFilter}>
                      {columns.find(
                        (header) =>
                          header.accessorKey === menuState.selectedColumn
                      )?.type != "select" ? (
                        <Button color="green">
                          Ajouter aux filtres en attente
                        </Button>
                      ) : null}
                    </Menu.Item> */}
                  </>
                )}
            </Menu.Dropdown>
          </Menu>
        </Flex>
      </div>
      {pendingFilters.length > 0 && (
        <Collapse in={true}>
          <>
            <Group position="apart" style={{ width: "100%" }} className="mt-1">
              <div style={{ display: "flex", marginLeft: "auto" }}>
                {pendingFilters.map((filter, index) => (
                  <Badge
                    key={index}
                    color="orange"
                    rightSection={
                      <ActionIcon
                        size="xs"
                        color="orange"
                        onClick={() => handleRemovePendingFilter(index)}
                      >
                        <Tooltip
                          label="Supprimer la sélection"
                          withArrow
                          position="top"
                          withinPortal
                        >
                          <IconX size={10} />
                        </Tooltip>
                      </ActionIcon>
                    }
                  >
                    <span
                      style={{ fontWeight: "normal", textTransform: "none" }}
                    >
                      {`${
                        columns.find(
                          (header) => header.accessorKey === filter.column
                        ).header +
                        " " +
                        filter.condition.toLowerCase()
                      }: ${
                        filter.value && filter.column
                          ? filter.condition === "select"
                            ? (() => {
                                const statut = String(filter.value);
                                const statutOptions =
                                  columns.find(
                                    (header) =>
                                      header.accessorKey === filter.column
                                  )?.options || [];
                                const statutLabels = statut
                                  .split(",")
                                  .map((val) => {
                                    const match = statutOptions.find(
                                      (option) => option.value === parseInt(val)
                                    );
                                    return match ? match.label : null;
                                  })
                                  .filter((label) => label !== null);
                                return statutLabels.join(", ");
                              })()
                            : filter.value
                          : ""
                      }`}
                    </span>
                  </Badge>
                ))}
              </div>

              <Tooltip
                label="Appliquer le filtre"
                withArrow
                position="top"
                withinPortal
              >
                <i
                  onClick={handleApplyPendingFilters}
                  className="bx bx-solid bx-check bx-tada"
                  style={{ fontSize: 32, color: "#01d758", cursor: "pointer" }}
                />
              </Tooltip>
            </Group>
          </>
        </Collapse>
      )}
    </>
  );
});

export default FiltreMantineTable;
